<template>
  <CardBase>
    <slot name="header" />
    <CardPadding>
      <div class="grid" :class="gridClasses"><slot /></div>
    </CardPadding>
    <div
      v-if="$slots.bottom"
      class="px-4 py-3 bg-gray-50 dark:bg-gray-700 text-right sm:px-6"
    >
      <slot name="bottom" />
    </div>
  </CardBase>
</template>

<script setup>
import CardBase from '@/Common/Layout/Containers/CardBase.vue'
import { computed } from 'vue'
import CardPadding from '@/Common/Layout/Containers/CardPadding.vue'

const props = defineProps({
  columns: {
    type: String,
    default: 'grid-cols-2',
  },
  gap: {
    type: String,
    default: 'gap-6',
  },
})

const gridClasses = computed(() => [props.columns, props.gap].join(' '))
</script>
